// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"38d3db17","236":"7e6572ee","703":"2e7a68dc","787":"3278c3d5"}[chunkId] + ".chunk.js";
};